import InfiniteScroll from "react-infinite-scroll-component";
import { Link } from "react-router-dom";
import useReactGASend from "../../../../hooks/useReactGASend";

const ProductList = ({
  productList,
  fetchMoreData,
  infinity,
  storeId,
  brandCd,
  areaCode,
  keyword,
  branchList,
}) => {
  const { makeEventTrackFn } = useReactGASend();
  const trackLinkClick = (title, body) => {
    makeEventTrackFn({
      category: "event",
      action: title,
      body,
    });
  };

  return (
    <InfiniteScroll
      dataLength={productList.length}
      next={fetchMoreData}
      hasMore={infinity}
    >
      <ul>
        {productList.map((product) => {
          const {
            sku_code,
            sku_nm,
            discounted_rate,
            discounted_price,
            sell_price,
            event,
            stock_status,
          } = product;
          return (
            <li key={sku_code} className="py-5 border-b border-neutral-100">
              <Link
                to={`/search/${sku_code}`}
                state={{ itemId: sku_code, storeId, brandCd }}
                onClick={() =>
                  trackLinkClick("상품검색(검색)", {
                    data_area_nm: areaCode,
                    data_store_nm:
                      branchList.find((item) => item.id === storeId)?.name ||
                      null,
                    data_store_cd: storeId,
                    data_keyword: keyword,
                    data_sku_cd: sku_code,
                    data_sku_nm: sku_nm,
                  })
                }
              >
                <h3 className="mb-2.5 text-lg font-medium truncate">
                  {sku_nm}
                </h3>
                {stock_status === "UNDISCLOSED" ? (
                  <p className="text-base font-bold">
                    가격 안내가 어려운 상품입니다.
                  </p>
                ) : (
                  <>
                    {discounted_rate ? (
                      <>
                        <div className="flex items-center gap-2">
                          <p className="text-base font-bold">
                            {discounted_rate}%
                          </p>
                          <p className="text-base font-semibold line-through text-neutral-400">
                            {sell_price.toLocaleString()}원
                          </p>
                        </div>
                        <p className="inline-flex items-center gap-2 text-sm font-semibold text-pink-600">
                          최대할인가
                          <span>
                            <b className="text-xl font-bold ">
                              {discounted_price.toLocaleString()}
                            </b>
                            원
                          </span>
                        </p>
                      </>
                    ) : (
                      <p className="text-base font-bold">
                        {sell_price.toLocaleString()}원
                      </p>
                    )}
                  </>
                )}
                <div
                  className="flex items-center"
                  style={{
                    justifyContent: "flex-end",
                  }}
                >
                  {event?.length > 0 && (
                    <p className="px-4 h-6 leading-6 bg-neutral-100 rounded-[19px] text-xs font-semibold text-center text-purple-500">
                      {event[0]?.title}
                    </p>
                  )}
                </div>
              </Link>
            </li>
          );
        })}
      </ul>
    </InfiniteScroll>
  );
};

export default ProductList;
